import { Star } from "lucide-react";

const GoldStars = ({ count = 5 }) => (
  <span className="flex items-center gap-0.5" aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <Star key={i} size={12} className="fill-[#c9a24b] text-[#c9a24b]" />
    ))}
  </span>
);

export const TrustBadges = () => (
  <div
    data-testid="trust-badges-bar"
    className="border-b border-[rgba(201,162,75,0.16)] bg-[#0e0d0c]"
  >
    <div className="mx-auto flex max-w-6xl flex-wrap items-center justify-center gap-x-10 gap-y-3 px-5 py-3 sm:px-8">
      <div className="flex items-center gap-2" data-testid="trust-badge-klarna">
        <span className="font-display text-sm tracking-[0.12em] text-[#f2ede3]">
          Klarna
        </span>
        <span className="text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-[#a09a8c]">
          Pay Later Available
        </span>
      </div>

      <span className="hidden h-4 w-px bg-[rgba(201,162,75,0.2)] sm:block" />

      <div className="flex items-center gap-2" data-testid="trust-badge-google">
        <GoldStars />
        <span className="text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-[#a09a8c]">
          Google Reviews
        </span>
      </div>

      <span className="hidden h-4 w-px bg-[rgba(201,162,75,0.2)] sm:block" />

      <div className="flex items-center gap-2" data-testid="trust-badge-trustpilot">
        <GoldStars />
        <span className="text-[0.6rem] font-semibold uppercase tracking-[0.22em] text-[#a09a8c]">
          Trustpilot · Rated Excellent
        </span>
      </div>
    </div>
  </div>
);
